import {
  ConnectorDataCollection,
  ConnectorDataLocation,
  ConnectorSpec,
  OperationListItem,
} from '@integration-app/sdk'

import { HeadMetatags } from 'routes/components/HeadMetatags'
import Container from 'routes/components/Layout/Container'
import { DefaultPageLayout } from 'routes/layouts'

import iconArrowLeft from 'routes/Connectors/Connector/arrow-left.svg'
import { ExecuteOperations } from 'routes/Connectors/Connector/components/ExecuteOperations'
import { IntegrationsOnEvents } from 'routes/Connectors/Connector/components/IntegrationsOnEvents'
import { ManagedAuthentication } from 'routes/Connectors/Connector/components/ManagedAuthentication'
import { WorkWithCollections } from 'routes/Connectors/Connector/components/WorkWithCollections'

import classes from './connector.module.css'
import NavLink from '../../components/NavLink'
import { UdmMapping } from './components/UdmMapping'
import { LINKS } from 'routes/constants'

export default function ConnectorPage({
  connector,
  connectorOperations,
  connectorData,
  similarConnectors,
}: {
  connector: ConnectorSpec
  connectorOperations: OperationListItem[]
  connectorData: ConnectorDataLocation[]
  similarConnectors: Array<ConnectorSpec>
}) {
  if (!connector) {
    return null
  }
  return (
    <DefaultPageLayout>
      <HeadMetatags
        title={`${connector.name} Connector for Your App`}
        description={`Add white-label customer-facing integration with ${connector.name} into your app with just a few lines of code.`}
        type={'article'}
      />
      <Container className={classes.wrapper}>
        <div className={classes.heroBlock}>
          <NavLink href={LINKS.CONNECTORS} className={classes.heroLink}>
            <img src={iconArrowLeft.src} alt='' />
            Back to all connectors
          </NavLink>
          <h1 className={classes.header}>
            <img
              src={connector.logoUri}
              className={classes.header_logo}
              alt='Logo'
            />
            {connector.name} integration connector
          </h1>
          <p className={classes.heroParagraph}>
            Add white-label customer-facing integration with {connector.name}{' '}
            into your app with just a few lines of code.
            {connector.hasReadme && (
              <>
                <br />
                <NavLink
                  href={`${LINKS.CONNECTORS}/${connector.key}/guide`}
                  className={classes.link}
                >
                  Read development guide
                </NavLink>
                .
              </>
            )}
          </p>
        </div>

        <ManagedAuthentication connector={connector} />

        <ExecuteOperations
          connector={connector}
          operations={connectorOperations}
        />

        <WorkWithCollections
          connector={connector}
          collections={
            connectorData.filter(
              (l) => l.type === 'collection',
            ) as ConnectorDataCollection[]
          }
        />

        {connectorData.length > 0 && (
          <IntegrationsOnEvents connector={connector} />
        )}

        {similarConnectors.length > 0 && (
          <UdmMapping
            connector={connector}
            similarConnectors={similarConnectors}
          />
        )}
      </Container>
    </DefaultPageLayout>
  )
}
